import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp } from "./motionPresets";

const ASSURANCES = [
  "Free 30-min walkthrough",
  "GST-ready out of the box",
  "Live in weeks, not months",
];

const HomeHero = () => (
  <section className="hero">
    <div className="hero__inner">
      <motion.div
        className="hero__text"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <p className="eyebrow">Business software, built in India</p>
        <h1>
          Software your team will <span className="accent">actually use.</span>
        </h1>
        <p className="hero__lead">
          Byteflow builds modular business software for the industries we know
          best — ERP for SMBs and manufacturers, and dedicated systems for
          courier, pharmacy, education, and e-commerce.
        </p>
        <div className="hero__ctas">
          <Link to="/contact" className="btn-primary">
            Request a Demo
          </Link>
          <Link to="/products" className="btn-secondary">
            Explore Products
          </Link>
        </div>
        <ul className="hero__assurances">
          {ASSURANCES.map((item) => (
            <li key={item}>
              <span aria-hidden>✓</span> {item}
            </li>
          ))}
        </ul>
        <div className="hero__rating">
          <span className="hero__stars" aria-hidden>★★★★★</span>
          <span>Rated 4.8/5 by 120+ businesses across India</span>
        </div>
      </motion.div>
      <motion.div
        className="hero__image"
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <img src="/about-erp.jpg" alt="Byteflow product preview" />
        <motion.div
          className="hero__float"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <span className="hero__float-value">↑ 32%</span>
          <span className="hero__float-label">faster order-to-cash</span>
        </motion.div>
      </motion.div>
    </div>
  </section>
);

export default HomeHero;
